import { Pipe, PipeTransform } from '@angular/core';
import { StatesService } from '../services/states.service';

@Pipe({
  name: 'filtersPipe'
})
export class FiltersPipePipe implements PipeTransform {
  constructor(private statesService: StatesService) {
  }

  transform(nurseryArray: Array<any>, filterPreferences: any, searchType: string): any {
    // is the nurseries state TRUE in the filter preferences? If yes, filter it in
    nurseryArray = nurseryArray.filter((nursery => {
      const somethingWithState = nursery.item || nursery;
      const state = this.statesService.getStateFromIdOrDefault(somethingWithState.state_id);
      return filterPreferences[state.state];
    }
  )).filter((nursery => ((nursery.item || nursery).distanceFromMe ? (nursery.item || nursery).distanceFromMe : 0) <= filterPreferences.maxDistance * 1609.344));
    if (searchType == 'Distance') {
      nurseryArray.sort((a, b) => (a.item || a).distanceFromMe.value - (b.item || b).distanceFromMe.value);
    } else if(searchType == 'Alphabetical') {
      nurseryArray.sort((a, b) => {
        if((a.item || a).name < (b.item || b).name) return -1;
        if((a.item || a).name > (b.item || b).name) return 1;
        return 0;
      });
    }
    return nurseryArray;
  }

}
